import { Injectable } from '@angular/core';
import {  Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { RestApi } from '../shared/apiUrls';
import { PromiseResult } from '../models/PromiseResult';
import { GenrateToken, PatientProfileQuery } from '../models/patient-profile';
import { catchError } from 'rxjs/operators';



@Injectable({
    providedIn: 'root'
})
export class PatientProfileService {

    constructor(private readonly http: HttpClient) { }

    
    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }


    GetProfile(query:PatientProfileQuery): Observable<PromiseResult> {
        let params=new HttpParams().set('patient_guid',query.patient_guid);
        if(query.consultation_id!=null){
            params=params.append('consultation_id',query.consultation_id.toString())
        }
        if(query.user_guid!=null && query.token!=null){
            params=params.append('token',query.token.toString())
            params=params.append('user_guid',query.user_guid.toString())
        }
        
        return this.http.get<PromiseResult>(RestApi.Urls.PatientAccountApi + "Get",{params:params})
            .pipe(catchError(this.handleError));
    }

    GenrateToken(query:GenrateToken): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.PatientAccountApi + "Share/Fetch/token",query)
            .pipe(catchError(this.handleError));
    }
}
